import React, {useEffect, useReducer, useState} from "react";
import cloneDeep from "lodash.clonedeep";
import {connect} from "react-redux";
import {Breadcrumb, Row, Button, Col, ButtonGroup, Glyphicon} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import locale from "../../../../../locale";
import {HALLS_BLOCKS_LIST, INITIAL_PAGE_MODEL} from "./models";
import {pages, pagesSettingsUpdate} from "../../../../../../api/cp";
import {eventPollGet} from "../../../../../../api/player";
import {Event} from "../../../../Comet";
import Loading from "../../../../Loading";
import SettingTabWrapper from '../../../Widgets/components/SettingTabWrapper';
import CommonHallsSettings from "./CommonHallsSettings";
import BlockSettings from "../../components/BlockSettings";

const HallsConstructorPage = ({event}) => {
    const [pageData, setPageData] = useState(null);
    const [pageSettings, updatePageSettings] = useReducer(
        (prev, next) => {
            return {...prev, ...next}
        },
        cloneDeep(INITIAL_PAGE_MODEL)
    );
    const [isPolls, setIsPolls] = useState(false);

    useEffect(fetchPageData, []);

    const pollsGet = async () => {
        const polls = await eventPollGet(event.eventKey);
        setIsPolls(!!polls.length);
    };

    useEffect(() => {
        pollsGet();
    }, []);

    async function fetchPageData() {
        const pagesList = await pages(event.eventKey);
        const hallsPage = pagesList?.find(({type}) => type === 'halls') ?? null;

        if (!!hallsPage) {
            setPageData(hallsPage)
            updatePageSettings({...pageSettings, ...hallsPage.settings});
        }
    }

    async function handleUpdateSettings(setting) {
        const formData = new FormData();

        Object.keys(setting).forEach((key) => {
            formData.append(key, setting[key]);
        });

        const response = await pagesSettingsUpdate(pageData.id, formData);
        updatePageSettings({...pageSettings, ...response.settings});
    }

    function handleCometUpdatePage(pageData) {
        if (pageData.type === 'halls') {
            setPageData(pageData);
        }
    }

    if (!pageData) {
        return <Loading />
    }

    return (
        <section>
            <Event event="update:page" handler={handleCometUpdatePage} />

            <Row>
                <Breadcrumb>
                    <LinkContainer to={`/event/${event.eventPassword}`}>
                        <Breadcrumb.Item>{locale('mainMenu.event')}</Breadcrumb.Item>
                    </LinkContainer>
                    <LinkContainer to={`/event/${event.eventPassword}/pages`}>
                        <Breadcrumb.Item>{locale('mainMenu.pages')}</Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>{locale('mainMenu.hallsConstructor')}</Breadcrumb.Item>
                </Breadcrumb>
            </Row>

            <Row>
                <Col xs={12}>
                    <ButtonGroup>
                        <LinkContainer to={`/event/${event.eventPassword}/pages`}>
                            <Button>
                                <Glyphicon glyph="menu-left"/>
                                {' '}
                                {locale('email.back')}
                            </Button>
                        </LinkContainer>
                    </ButtonGroup>
                </Col>
            </Row>

            <Row style={{marginTop: '20px'}}>
                <Col xs={4}>
                    <SettingTabWrapper
                        label="commonBroadcastSettings"
                        title={locale('settings.tab.title.common')}
                    >
                        <CommonHallsSettings
                            pageSettings={pageSettings}
                            onChangePageSettings={updatePageSettings}
                            onSaveSettings={handleUpdateSettings}
                            isSettingsMobileOpenModule={event?.moduleComment?.enabled || event?.moduleQuestion?.enabled || isPolls}
                        />
                    </SettingTabWrapper>
                    <SettingTabWrapper
                        label="BlockSettings"
                        title={locale('settings.tab.title.blocks')}
                    >
                        <BlockSettings
                            event={event}
                            pageId={pageData.id}
                            blocks={pageData.blocks}
                            options={HALLS_BLOCKS_LIST}
                        />
                    </SettingTabWrapper>
                </Col>
                <Col xs={8}>
                    <iframe
                        name="broadcastPage"
                        src={`/event/${event.eventKey}/halls`}
                        style={{width: '100%', height: '100dvh'}}
                        frameBorder="0"
                    />
                </Col>
            </Row>
        </section>
    );
};

const mapStateToProps = (store) => ({
    event: store.currentEvent,
});

export default connect(mapStateToProps)(HallsConstructorPage);
